import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MarketplaceTeammate } from '@app/shared/interfaces/lib/task.interface';
import { AlertComponent, LoadingSpinnerComponent } from '@ui';
import { CleanerCardComponent } from '../../cleaner-card/cleaner-card.component';

@Component({
  selector: 'sbnb-add-task-rule-flow-cleaners',
  standalone: true,
  imports: [CommonModule, AlertComponent, CleanerCardComponent, LoadingSpinnerComponent],
  templateUrl: './add-task-rule-flow-cleaners.component.html',
})
export class AddTaskRuleFlowCleanersComponent {
  cleaners = input<MarketplaceTeammate[]>([]);
  loading = input<boolean>(false);
}
